import "@/styles/packages.scss"

import { register } from "../helpers/stimulus"

import { setupAccordions } from "@/components/content/Accordion"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import TooltipController from "../controllers/tooltip_controller"
import VoucherFormController from "../controllers/voucher_form_controller"

const setupStimulus = (): void => {
  register("disclosure-item", DisclosureItemController)
  register("facilities-modal", ModalController)
  register("facilities-modal-trigger", ModalTriggerController)
  register("tooltip", TooltipController)
  register("voucher-form", VoucherFormController)
}

setupStimulus()
setupAccordions()
